/// <amd-module name="Feed/IvyPromote/Redux/IvyPromote/IvyPromoteContracts" />
import { IFeedHubViewAwareState } from "Feed/Core/Redux/FeedHub";

export interface IIvyPromoteOwnState {
    ivyPromoteState: IIvyPromoteState;
}

export interface IIvyPromoteAwareState extends IIvyPromoteOwnState, IFeedHubViewAwareState {}

export interface IIvyPromoteState {
    isSaving: boolean;
    statuses: string[];
    currentStatus: string;
    errorMessage?: string;
}
